import { render, staticRenderFns } from "./DeletePayrollData.vue?vue&type=template&id=1288d4f8&scoped=true"
import script from "./DeletePayrollData.vue?vue&type=script&lang=js"
export * from "./DeletePayrollData.vue?vue&type=script&lang=js"
import style0 from "./DeletePayrollData.vue?vue&type=style&index=0&id=1288d4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288d4f8",
  null
  
)

export default component.exports